import React from 'react';
import { CodeBlock } from 'react-code-blocks';
import ApiTableRow from '../api-table-row/ApiTableRow';
import { exampleErrorResponses, headerCode } from './ApiLabelCodeBlocks';
import { codeBlockTheme } from '../utilities';

const ApiLabelPage: React.FC<{
  data: any
  searchValue: string
  currentApiElement: any
}> = ({
  data,
  searchValue,
  currentApiElement
}) => {

  return (
    <div className="api-retrieve-label-page">
      <h2>Retrieve Label</h2>
      <p>To retrieve label information for a booking.</p>

      <div className="api-url-box">
        <strong>GET</strong>/public/v1/retrieve/label/amiReference
      </div>

      <div className="api-grid">
{/* Header Parameters */}
        <h2 id="label-header-schema">Retrieve Label Header Parameters</h2>

        <div className="api-grid__table">
          <div className="api-grid__table__head">
            <h3>Parameter</h3>
            <h3>Constraint / Description</h3>
          </div>

          <div className="api-grid__table__body">

            {data && data.headers?.map((row: any, index: number) => {
              return (
                <ApiTableRow
                  key={index + row.title}
                  rowInfo={row}
                  searchValue={searchValue}
                  currentApiElement={currentApiElement}
                ></ApiTableRow>
              )
            })}
          </div>
        </div>

{/* ResponseSuccess */}
        <h2 id="label-body-schema">Quote Response Success</h2>

        <div className="api-grid__table">
            <div className="api-grid__table__head">
              <h3>Parameter</h3>
              <h3>Constraint / Description</h3>
            </div>

            <div className="api-grid__table__body">

            {data && data.responseSuccess?.map((row: any, index: number) => {
              return (
                <ApiTableRow
                  key={index + row.title}
                  rowInfo={row}
                  searchValue={searchValue}
                  currentApiElement={currentApiElement}
                ></ApiTableRow>
              )
            })}
          </div>
        </div>

        <div className="api-grid__example api-grid__example--header">
          <h3>Example Header</h3>
          {/* @ts-ignore */}
          <CodeBlock
            //@ts-ignore
            text={headerCode}
            language='javascript'
            showLineNumbers={true}
            theme={codeBlockTheme}
          />
        </div>

        <div></div>

{/* ResponseError */}
        <h2 id="label-response-error-schema">Label Response Errors</h2>

        <div className="api-grid__table__head">
          <h3>Error Code</h3>
          <h3>Constraint / Description</h3>
        </div>
        {data && data.responseError?.map((row: any, index: number) => {
          return (
            <React.Fragment key={index + row.title}>
              <div className="api-grid__table api-grid__table--error-response">
                <div className="api-grid__table__body">
                  <ApiTableRow
                    rowInfo={row}
                    searchValue={searchValue}
                    currentApiElement={currentApiElement}
                  ></ApiTableRow>
                </div>
              </div>
              <div className="api-grid__example api-grid__example--error-response">
                {/* @ts-ignore */}
                <CodeBlock
                  //@ts-ignore
                  text={exampleErrorResponses[row.title]}
                  language='javascript'
                  showLineNumbers={true}
                  theme={codeBlockTheme}
                />
              </div>
            </React.Fragment>
          )
        })}

      </div>
    </div>
  )

}

export default ApiLabelPage;